import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ton </span>
            from <span className="purple"> Thailand</span>
            <br />I am a Network Engineer Work and DayTrader..
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Day Trading
            </li>
            <li className="about-activity">
              <ImPointRight /> Looking fore new technology
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Choose to walk in what you love!"{" "}
          </p>
          <footer className="blockquote-footer">Ton</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
